import { render, staticRenderFns } from "./PointForm.vue?vue&type=template&id=41f2f8bf&"
import script from "./PointForm.vue?vue&type=script&lang=ts&"
export * from "./PointForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports